var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1043_41921)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 50,
    rx: 6,
    fill: "url(#paint0_linear_1043_41921)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.6666 20.1118V28.6868C41.3283 28.5235 40.9549 28.4068 40.5349 28.3368L40.1733 28.2785L39.8699 27.6485C39.2282 26.3418 38.1783 25.5835 36.9999 25.5835C35.8216 25.5835 34.7716 26.3418 34.1299 27.6485L33.8149 28.2785L33.4649 28.3368C32.0766 28.5702 31.0732 29.3402 30.7116 30.4368C30.3616 31.5452 30.7233 32.7585 31.7149 33.7618L32.0766 34.1235L32.0416 34.2635C31.8083 35.3018 31.9016 36.0952 32.1233 36.6668H25.1116C20.8649 36.6668 18.3333 34.1352 18.3333 29.8885V20.1118C18.3333 15.8652 20.8649 13.3335 25.1116 13.3335H34.8883C39.1349 13.3335 41.6666 15.8652 41.6666 20.1118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3067 28.4302L38.6801 29.1885C38.8667 29.5618 39.3451 29.9118 39.7417 29.9818L40.2434 30.0635C41.7717 30.3202 42.1217 31.4402 41.0367 32.5368L40.57 33.0035C40.255 33.3185 40.0917 33.9252 40.1851 34.3685L40.2434 34.6485C40.6634 36.4918 39.6834 37.2035 38.085 36.2352L37.7467 36.0252C37.3384 35.7802 36.6617 35.7802 36.2534 36.0252L35.9151 36.2352C34.3051 37.2035 33.3367 36.4918 33.7567 34.6485L33.815 34.3685C33.9084 33.9368 33.7451 33.3185 33.4301 33.0035L32.9634 32.5368C31.8784 31.4285 32.2284 30.3202 33.7567 30.0635L34.2584 29.9818C34.6667 29.9118 35.1334 29.5618 35.32 29.1885L35.6934 28.4302C36.4167 26.9718 37.5834 26.9718 38.3067 28.4302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8178 20.2367C35.1998 20.5328 35.2694 21.0824 34.9733 21.4643L32.2731 24.9477C31.5791 25.8254 30.2995 25.9855 29.4067 25.2956L29.4006 25.2909L27.2696 23.6141C27.138 23.5141 26.9544 23.5389 26.8544 23.6679C26.8543 23.668 26.8545 23.6678 26.8544 23.6679L24.0783 27.2722C23.7834 27.655 23.234 27.7264 22.8511 27.4315C22.4683 27.1366 22.397 26.5872 22.6918 26.2043L25.4694 22.5983C26.1622 21.7016 27.447 21.5395 28.3417 22.2309L28.3478 22.2356L30.4788 23.9125C30.6119 24.0135 30.7993 23.9875 30.8986 23.8644L33.5902 20.3922C33.8863 20.0103 34.4359 19.9406 34.8178 20.2367Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1043_41921",
    x: 0,
    y: 0,
    width: 60,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_41921"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_41921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1043_41921"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1043_41921",
    result: "effect2_dropShadow_1043_41921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1043_41921",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_41921",
    x1: 60,
    y1: 0,
    x2: 10.8197,
    y2: 59.0164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20CED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.62d545d6b447959f91e22de18c448e93.svg";
export { ForwardRef as ReactComponent };